import { render, staticRenderFns } from "./request_types.vue?vue&type=template&id=f1334f78&"
import script from "./request_types.vue?vue&type=script&lang=js&"
export * from "./request_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports